var React = require('react');

function Quote (props) {
    return React.createElement("svg",props,React.createElement("g",null,React.createElement("path",{"d":"M0,9.48c0-2.11,0.5-3.77,1.51-5s2.47-2.02,4.4-2.4v2.19c-1.43,0.45-2.4,1.22-2.89,2.32C2.76,7.16,2.66,7.76,2.7,8.38h3.31\nv5.54H0V9.48z M9.99,9.48c0-2.14,0.52-3.81,1.55-5.02s2.48-2,4.35-2.38v2.19c-1.42,0.44-2.38,1.22-2.87,2.36\nc-0.28,0.6-0.39,1.19-0.34,1.75H16v5.54H9.99V9.48z"})));
}

Quote.defaultProps = {"version":"1.1","x":"0px","y":"0px","viewBox":"0 0 16 16","style":{"enableBackground":"new 0 0 16 16"},"xmlSpace":"preserve"};

module.exports = Quote;

Quote.default = Quote;
